import React, { Component } from "react";
import { Spin, Select } from "antd";
import ClinicDetailsTabView from "./ClinicDetailsTabView";
import { getClinicDetails } from "../../services";
import { showErrorNotification, getProp } from "../../helpers";
import UpdateClinicLocationModal from "./UpdateClinicLocationModal";

const { Option } = Select;

/**
 * @function getCurrentTabName
 * @params pathName
 * @description It will return the current active tab
 */
const getCurrentTabName = pathName => {
  let currentPage = null;
  // get pathName like '/settings/vitals'
  // find the number of `/` and get the array length
  const pathLength = (pathName.match(new RegExp("/", "g")) || []).length;
  // if pathName has only 1 '/'
  if (pathLength === 1) {
    currentPage = pathName.replace("/", "");
  } else if (pathLength === 2) {
    const path1 = pathName.substring(1).split("/")[0];
    currentPage = path1;
  } else {
    // if pathName has 2 '/'  like '/settings/network
    const path = pathName.substring(1).split("/")[2];

    currentPage = path;
  }

  return currentPage;
};

export default class ClinicDetailsTabsContainer extends Component {
  constructor(props) {
    super(props);
    const { clinicId } = this.props.match.params;
    this.state = {
      isProcessing: false,
      clinicId: clinicId,
      details: {},
      showLocationModal: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // get pathname like '/settings/vitals' from url
    const pathName = nextProps.location.pathname;

    const currentPage = getCurrentTabName(pathName);
    if (!prevState.currentPath !== currentPage) {
      return { currentPath: currentPage };
    }
    return null;
  }

  componentDidMount() {
    const { clinicId } = this.props.match.params;

    this.setState({ clinicId, isProcessing: true }, () => {
      this.getClinicInfo();
    });
  }

  /**
   * @function getClinicInfo.
   * @description it will get the clinic info
   */
  getClinicInfo = () => {
    const { clinicId } = this.state;
    this.setState({ isProcessing: true });
    getClinicDetails(clinicId)
      .then(response => {
        this.setState({ isProcessing: false });
        const getErrors = getProp(["data", "errors"]);
        const getSuccess = getProp(["data", "success"]);
        const getDataSuccess = getProp(["data", "data"]);

        if (getSuccess(response)) {
          const details = getDataSuccess(response);
          this.setState({
            details,
            isProcessing: false
          });
        } else if (getErrors(response)) {
          const { errors } = response.data;

          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      })
      .catch(response => {
        const getErrors = getProp(["data", "errors"]);
        if (getErrors(response)) {
          const { errors } = response.data;
          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      });
  };

  /**
   * @function refreshClinnicDetails
   * @desc it will refresh the details
   *
   */
  refreshClinicDetails = clinicId => {
    this.setState({ clinicId, details: {} }, () => {
      this.getClinicInfo();
    });
  };

  handleEditLocation = (showBoolen, refreshDetail) => {
    this.setState({ showLocationModal: showBoolen }, () => {
      if (refreshDetail) this.getClinicInfo();
    });
  };

  render() {
    const {
      currentPath,
      isProcessing,
      details,
      clinicId,
      showLocationModal
    } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <div className="reputation-wrapper">
          <div className="content-container">
            {/* heading block start */}
            <div className="heading">
              <div className="left">
                {details && details.is_hospital ? "Hospital" : "Clinic"} Details
              </div>
            </div>
            {/* heading block end */}
            {details && (
              <ClinicDetailsTabView
                refreshClinicDetails={this.refreshClinicDetails}
                currentPath={currentPath}
                details={details}
                clinicId={clinicId}
                getClinicInfo={this.getClinicInfo}
                handleEditLocation={this.handleEditLocation}
              />
            )}

            {showLocationModal && (
              <UpdateClinicLocationModal
                showModal={showLocationModal}
                toggleModal={this.handleEditLocation}
                clinicDetail={details}
              />
            )}
          </div>
        </div>
      </Spin>
    );
  }
}
